'use strict';

import jumper from './jumper';

const menu = {
  fixedClass: 'is-fixed',
  body: document.body,
  cover: document.getElementById('cover'),
  mainHeader: document.querySelector('.main-header'),
  navMenu: document.getElementById('navMenu'),
  progressContainer: document.querySelector('.reading-progress'),
  progressBar: document.querySelector('.progress-bar'),
  mobTocLink: document.querySelector('.mobile-menu'),
  tocLink: document.querySelector('.table-of-contents'),
  sections: document.querySelectorAll('.content-section'),
  jumpers: document.querySelectorAll('.jump-to-pointer'),
  init() {
    this.tocLink.addEventListener('click', this.tocControl.bind(this));
    this.mobTocLink.addEventListener('click', this.mobTocControl.bind(this));
    for (let index = 0; index < this.jumpers.length; index++) {
      this.jumpers[index].addEventListener('click', this.jumpersControl.bind(this));
    }
  },
  setMenuPosition() {
    const cover = this.cover.getBoundingClientRect().bottom;
    if (cover < 0) this.body.classList.add(this.fixedClass);
    if (cover > 0) this.body.classList.remove(this.fixedClass);
  },
  setReadingProgress() {
    const total = this.body.clientHeight - window.innerHeight;
    const percentage = 100 * (window.pageYOffset / total);

    this.progressBar.style.width = percentage + '%';
  },
  setMenuLinkActive(e) {
    const windowTop = window.pageYOffset;

    for (const section of this.sections) {
      const rect = section.getBoundingClientRect();
      const top = rect.top + windowTop - 80;

      const menulink = document.getElementById('menulink-' + section.id);
      menulink.classList.remove('active');

      if (windowTop > top && windowTop < top + rect.height) {
        menulink.classList.add('active');
      }
    }
  },
  getShape() {
    return {
      width: this.mainHeader.clientWidth,
      height: this.mainHeader.clientHeight,
      nav: {
        width: this.mainHeader.firstChild.clientWidth,
        height: this.mainHeader.firstChild.clientHeight
      },
      progress: {
        width: this.progressContainer.clientWidth,
        height: this.progressContainer.clientHeight
      }
    };
  },
  scrollHandler() {
    this.setMenuPosition.bind(this)();
    this.setReadingProgress.bind(this)();
    this.setMenuLinkActive.bind(this)();
  },
  tocControl(e) {
    e.preventDefault();
    if (this.body.classList.contains(this.fixedClass)) {
      this.navMenu.classList.toggle('active');
      this.body.classList.toggle('no-scroll');
    } else {
      jumper.jump(document.getElementById('table-of-contents'));
    }
  },
  mobTocControl(e) {
    e.preventDefault();
    this.navMenu.classList.toggle('active');
    this.body.classList.toggle('no-scroll');
  },
  jumpersControl(e) {
    e.preventDefault();
    this.navMenu.classList.remove('active');
    this.body.classList.remove('no-scroll');

    const hash = e.target.hash || e.target.parentNode.hash;

    setTimeout(function() {
      jumper.jump(document.querySelector(hash));
    }, 333);
  }
};

export default menu;
